"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var edit_note_controller_1 = __importDefault(require("./edit-note.controller"));
var edit_note_html_1 = __importDefault(require("./edit-note.html"));
function getStudent($stateParams, UsersModel) {
    return UsersModel.getStudentByID($stateParams.userId).then(function (response) {
        return response;
    });
}
getStudent.$inject = ["$stateParams", "UsersModel"];
function getNote($stateParams, UsersModel) {
    return UsersModel.getStudentNote($stateParams.userId, $stateParams.note_id).then(function (response) {
        var note = Object.assign({}, response.note);
        note.allowed_roles = {
            students: response.note.allowed_roles.includes(1),
            instructors: response.note.allowed_roles.includes(3),
            owners: response.note.allowed_roles.includes(4),
            administrators: response.note.allowed_roles.includes(5),
            staff: response.note.allowed_roles.includes(9),
        };
        return note;
    });
}
getNote.$inject = ["$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.edit-note", {
        url: "/notes/{note_id}/edit",
        controller: edit_note_controller_1.default,
        controllerAs: "vm",
        template: edit_note_html_1.default,
        resolve: {
            student: getStudent,
            note: getNote,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.editnote", [])
    .config(config)
    .controller("AdminStudentEditNoteController", edit_note_controller_1.default);
